export default function () {
  return {
    errors: {},
    success: false,
    error: false,
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ],
    actionTypes: [
      { value: 'close', label: 'Fechar' },
      { value: 'link', label: 'Link' }
    ],
    actionTargets: [
      { value: '_self', label: 'Mesma aba' },
      { value: '_blank', label: 'Nova aba' }
    ],
    actionColors: [
      { value: 'primary', label: 'Primário (azul)' },
      { value: 'secondary', label: 'Secundário (cinza)' },
      { value: 'success', label: 'Sucesso (verde)' },
      { value: 'danger', label: 'Erro (vermelho)' },
      { value: 'warning', label: 'Aviso (amarelo)' },
      { value: 'info', label: 'Info (azul claro)' },
      { value: 'light', label: 'Claro' },
      { value: 'dark', label: 'Escuro' }
    ],
    datePickerConfig: {
      nextMonthCaption: 'Próximo mês',
      prevMonthCaption: 'Mês anterior',
      setTimeCaption: 'Hora',
      weekdays: [
        'S', 'T', 'Q', 'Q', 'S', 'S', 'D'
      ],
      months: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]
    },
    modal: {
      title: '',
      body: '',
      actions: [],
      profileTypes: [],
      startDate: null,
      endDate: null,
      withoutPagarmeIdOnly: false,
      persistentWithoutPagarmeIdDate: null,
      enabled: true,
    }
  }
}
